import axios from "axios";

let base = process.env.REACT_APP_API_URL;
let base_prediction = process.env.REACT_APP_PREDICTION_URL;
if (base === undefined) {
  base = window.location.origin;
  base_prediction = window.location.origin;
}

let api_root = "";
let prediction_root = "";
if (
  process.env.REACT_APP_NODE_ENV === "dev" ||
  process.env.NODE_ENV === "production"
) {
  api_root = "/api";
  prediction_root = "/prediction";
}

const getTotalAccuracy = async (dateFrom, dateTo) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/accuracy`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
      },
    });
    if (response.data.length === 0) {
      return null;
    }
    return response.data[0].accuracy;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getAccuracyByPersonType = async (dateFrom, dateTo) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/accuracy`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        groupBy: "data.personType",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getAccuracyByPersonName = async (dateFrom, dateTo, personNames) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/accuracy`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        personNames: personNames?.join("-"),
        groupBy: "data.personName",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getWorstOpinators = async (dateFrom, dateTo, limit) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/accuracy`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        groupBy: "data.personName, data.personType",
        limit: limit,
        sortAccuracy: 1,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getBestOpinators = async (dateFrom, dateTo, limit) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/accuracy`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        groupBy: "data.personName, data.personType",
        limit: limit,
        sortAccuracy: -1,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getAccuracyBySexAndWeight = async (dateFrom, dateTo) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/accuracy/`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        groupBy: "data.animals.weight, data.animals.sex",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getAccuracyBySexAndWeightByPerson = async (
  dateFrom,
  dateTo,
  personNames
) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/accuracy/`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        groupBy:
          "data.animals.weight, data.animals.sex, data.animals.personName",
        personNames: personNames?.join("-"),
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getOpinatorNames = async () => {
  try {
    const response = await axios.get(
      `${base}${api_root}/opinions/opinators/unique`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// Semaphore
const getSemaphore = async (dateFrom, dateTo) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/semaphore`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getNumberOfOpinionsByPersonType = async (dateFrom, dateTo) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions/variation`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        groupBy: "data.personType, data.animals.variation",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getOpinions = async (
  dateFrom,
  dateTo,
  personNames,
  addIAPrediction = true
) => {
  try {
    const response = await axios.get(`${base}${api_root}/opinions`, {
      withCredentials: true,
      params: {
        from: dateFrom,
        to: dateTo,
        personNames: personNames?.join("-"),
        addIAPrediction: addIAPrediction,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const updateOpinions = async (date) => {
  try {
    const response = await axios.post(
      `${base_prediction}${prediction_root}/scrap-opinions`,
      {
        date: date,
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const makePredictions = async (date) => {
  try {
    const response = await axios.post(
      `${base_prediction}${prediction_root}/predictions`,
      {
        date: date,
      }
    );
    if (response.status === 202) {
      return response.status;
    }
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getPredictionStatus = async () => {
  try {
    const response = await axios.get(
      `${base_prediction}${prediction_root}/predictions/status`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return { status: null };
  }
};

const getOpinatorStatus = async () => {
  try {
    const response = await axios.get(
      `${base_prediction}${prediction_root}/opinions/status`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return { status: null };
  }
};

export {
  getAccuracyByPersonType,
  getAccuracyBySexAndWeight,
  getAccuracyBySexAndWeightByPerson,
  getBestOpinators,
  getNumberOfOpinionsByPersonType,
  getSemaphore,
  getOpinatorNames,
  getOpinions,
  getTotalAccuracy,
  getWorstOpinators,
  getAccuracyByPersonName,
  updateOpinions,
  makePredictions,
  getPredictionStatus,
  getOpinatorStatus,
};
